















import { Vue, Component, Prop } from 'vue-property-decorator';
import { debounce } from 'lodash';
import * as api from '@/api';
/**
 * 用户搜索框
 *
 * @author liyuyao
 * @date 04/22/2019
 */
@Component({
    components: {}
})
export default class SearchAboutDropdown extends Vue {
    @Prop({ default: '请输入TT标题' })
    placeholder: '';

    @Prop({ default: 'bottom-end' })
    placement: '';

    debounceSearchTicketByName: Function = debounce(this.searchTicketByName, 200);
    targetTitle: string = '';
    searchResult: any = [];

    async searchTicketByName(query) {
        if (query.trim().length < 1) {
            this.searchResult = [];
            return;
        }
        try {
            const res = await api.ticketApi.searchTicketByName(query);
            this.searchResult = res.data.items;
        } catch (e) {
            this.searchResult = [];
            console.log(e);
        }
    }
    targetItemClick(username, displayName) {
        // 选中后清空搜索记录
        this.searchResult = [];
        this.targetTitle = '';
        this.$emit('change', username, displayName);
    }
}
